export default __webpack_public_path__ + "static/media/thirdman.fd6b0541.jpg";